module.exports = __webpack_public_path__ + "static/img/mamanvogue-02.fe19eb0.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mamanvogue-02.webp
// module id = 113
// module chunks = 0